import "../../../../assets/css/components/AnalyticsGraph.css";
import AnalyticsGraphComponent from "../../../pages/dashboard/graphs/AnalyticsGraphComponent";
import { visitorChartOptions } from "../../../../utils/utilHelpers";
import FilterImage from "../../../../assets/icons/filter.svg";

const AnalyticsGraph = ({ chartData }) => {
    return (
        <div className="analytics-main-container">
            <div className="analytics-header" style={{ height: "65px" }}>
                <p>
                    BOTAG ANALYTICS &nbsp; <i className="fa-light fa-circle-info"></i>
                </p>
                <div className="headers-data">
                    <div className="cta-group">
                        <div className="cta">
                            <div className="switch-button active">Daily</div>
                            <div className="switch-button">Weekly</div>
                            <div className="switch-button">Mothly</div>
                        </div>
                        <div className="filter">
                            <div className="filter-image">
                                <img src={FilterImage} alt="" />
                            </div>
                            <div className="filter-by">Filter By:</div>
                            <div className="filter-by-arrow">
                                <i
                                    className="fa-light fa-chevron-down"
                                    style={{ color: "#d1d1d1", fontSize: "10px" }}></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div>
                <AnalyticsGraphComponent
                    type="bar"
                    height="254"
                    width="100%"
                    options={visitorChartOptions}
                    series={chartData}
                />
            </div>
        </div>
    );
};

export default AnalyticsGraph;
